module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/borders-default.bdaf4b7e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/borders-default.png
// module id = 2831
// module chunks = 11